import { useQuery } from "react-query";
import { HubunganKeluargaSelectionResponse } from "../../../../models/SusunanKeluarga";
import { getApiInstance } from "../../../api";
import queryWrapper from "../../queryWrapper";
import ApiClient from "../../../apiClient";

export const hubunganKeluargaSelectionKey = "hubungan-keluarga-selection-key";

export async function hubunganKeluargaSelection(): Promise<
  HubunganKeluargaSelectionResponse[]
> {
  const res = await ApiClient.get(`/HubunganKeluargaSelection`);
  return res.data;
}

export default function useFetchHubunganKeluargaSelection() {
  return useQuery(
    [hubunganKeluargaSelectionKey],
    queryWrapper(hubunganKeluargaSelection)
  );
}
